import { Minus, Plus, RotateCcw } from 'lucide-react';

import { Button } from '../../components/ui/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '../../components/ui/tooltip';

interface FontSizeStepperProps {
  /** Текущий кегль в пикселях кадра. */
  value: number;
  min?: number;
  max?: number;
  onChange: (delta: number) => void;
  /** Размер подобран сам — тогда кнопка сброса не нужна. */
  isAuto: boolean;
  onReset: () => void;
  disabled?: boolean;
}

/**
 * Кегль заголовка: минус, значение, плюс.
 *
 * Был в двух местах и в двух видах — «A−/A+» у постов и «−/+» у рилсов, причём
 * в форме рилса оба сразу. Один компонент вместо трёх: значение видно всегда,
 * «авто» — это состояние, а не отдельная подпись под блоком.
 */
export function FontSizeStepper({
  value,
  min = 12,
  max = 200,
  onChange,
  isAuto,
  onReset,
  disabled,
}: FontSizeStepperProps): JSX.Element {
  const size = Math.round(value);

  return (
    <div className="flex items-center gap-2">
      <div className="inline-flex items-center rounded-md border">
        <Button
          type="button"
          variant="ghost"
          size="icon"
          className="rounded-r-none"
          aria-label="Уменьшить"
          disabled={disabled || size <= min}
          onClick={() => onChange(-2)}
        >
          <Minus />
        </Button>
        <span className="w-24 text-center text-sm tabular-nums">
          {size} px{isAuto && <span className="text-muted-foreground"> · авто</span>}
        </span>
        <Button
          type="button"
          variant="ghost"
          size="icon"
          className="rounded-l-none"
          aria-label="Увеличить"
          disabled={disabled || size >= max}
          onClick={() => onChange(2)}
        >
          <Plus />
        </Button>
      </div>

      {!isAuto && (
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              type="button"
              variant="ghost"
              size="icon"
              aria-label="Вернуть автоподбор"
              onClick={onReset}
            >
              <RotateCcw />
            </Button>
          </TooltipTrigger>
          <TooltipContent>Вернуть автоподбор</TooltipContent>
        </Tooltip>
      )}
    </div>
  );
}
